export default "__VITE_ASSET__2c55b85c__"